export function validateFormMessage(form, erreurs) {
  let isValid = true;

  // Validation du nom
  if (!form.nomComplet.trim()) {
    erreurs.nomComplet = "Un nom complet est requis.";
    isValid = false;
  } else if (form.nomComplet.length > 100) {
    erreurs.nomComplet = "Le nom ne peut pas dépasser 100 caractères.";
    isValid = false;
  } else {
    erreurs.nomComplet = "";
  }

  // Validation de l'email
  if (!form.email.trim()) {
    erreurs.email = "Une adresse courriel est requise.";
    isValid = false;
  } else if (!isValidEmail(form.email)) {
    erreurs.email = "Une adresse courriel valide est requise.";
    isValid = false;
  } else {
    erreurs.email = "";
  }

  // Validation du sujet
  if (!form.sujet.trim()) {
    erreurs.sujet = "Un sujet est requis.";
    isValid = false;
  } else if (form.sujet.length > 60) {
    erreurs.sujet = "Le sujet ne peut pas dépasser 60 caractères.";
    isValid = false;
  } else {
    erreurs.sujet = "";
  }

  // Validation du message
  if (!form.message.trim()) {
    erreurs.message = "Un message est requis.";
    isValid = false;
  } else if (form.message.length > 500) {
    erreurs.message = "Le message ne peut pas dépasser 500 caractères.";
    isValid = false;
  } else {
    erreurs.message = "";
  }

  return isValid;
}

// Fonction de validation de l'adresse email
function isValidEmail(email) {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
}